import { Box } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { AddButtonProps } from "./add-button.props";
import { OutlinedButton } from "../outlined-button/outlined-button.component";

export const AddButton = ({ text, onClick, disabled, num, ...rest }: AddButtonProps) => (
  <OutlinedButton disabled={!!disabled} small="true" {...rest} onClick={onClick}>
    <AddIcon />
    <Box ml={2}>{text ? text : num}</Box>
  </OutlinedButton>
);
